import { memo } from "react";
import ClientOnly from "../shared-components/ClentOnly";
import ImageWithSkeleton from "../shared-components/ImageWithSkeleton";

function ArticalImage({
  thumb_img,
  alt,
  ogImageIsNotAvailable = false,
}: {
  thumb_img: {
    small: string;
    medium: string;
    large: string;
    hd: string;
    original: string;
  };
  alt: string;
  ogImageIsNotAvailable?: boolean;
}) {
  const imageProps = {
    url: {
      small: thumb_img.small,
      medium: thumb_img.medium,
      large: thumb_img.large,
      hd: thumb_img.hd,
      original: thumb_img.original,
    },
    alt,
    className: `w-full h-full shadow-md rounded-xl`,
    roundedClass: "rounded-xl",
  };

  return (
    <div className="w-full aspect-[16/9] rounded-xl overflow-hidden bg-gray-200">
      <ClientOnly fallback={<ImageWithSkeleton {...imageProps} isPreloaded={true} />}>
        <ImageWithSkeleton {...imageProps} isPreloaded={false} />
      </ClientOnly>
    </div>
  );
}

export default memo(ArticalImage);
